import { File } from "graphql/types"

export const createCaption = (image: File) => {
  if (image.description && image.description !== "") {
    return `${image.name} ${image.description}`
  }

  return image.name
}
